import React, { useState, useEffect } from 'react';
import { useSubscription } from '../hooks/useSubscription';
import { getPlanDisplayName } from '../config/entitlements';

export default function SubscriptionUpgradeNotification() {
  const { effectiveTier, planId, isSubscriptionActive, loading } = useSubscription();
  const [showNotification, setShowNotification] = useState(false);
  const [previousPlanKey, setPreviousPlanKey] = useState(null);

  useEffect(() => {
    const currentPlanKey = planId || effectiveTier;
    if (!loading && isSubscriptionActive && effectiveTier !== 'free') {
      if (previousPlanKey === null) {
        setPreviousPlanKey(currentPlanKey);
      } else if (previousPlanKey !== currentPlanKey) {
        setShowNotification(true);
        setPreviousPlanKey(currentPlanKey);

        const timer = setTimeout(() => {
          setShowNotification(false);
        }, 5000);

        return () => clearTimeout(timer);
      }
    } else if (!loading) {
      setPreviousPlanKey(currentPlanKey);
    }
  }, [effectiveTier, isSubscriptionActive, loading, planId, previousPlanKey]);

  if (!showNotification) return null;

  const displayName = planId ? getPlanDisplayName(planId) : (effectiveTier === 'basic' ? 'Basic' : effectiveTier === 'pro' ? 'Pro' : effectiveTier);

  return (
    <div className="fixed top-4 right-4 z-50 max-w-sm">
      <div className="bg-green-50 border border-green-200 rounded-lg p-4 shadow-lg">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-green-800">
              Subscription Upgraded!
            </h3>
            <p className="mt-1 text-sm text-green-700">
              Your account has been upgraded to {displayName}. You now have access to all {displayName} features!
            </p>
          </div>
          <div className="ml-auto pl-3">
            <button
              onClick={() => setShowNotification(false)}
              className="inline-flex text-green-400 hover:text-green-600"
            >
              <span className="sr-only">Close</span>
              <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
} 
